import { getImageUrl } from "../../../config/apiUrls";
import { ImageSize } from "../../../constants/imageSizes";
import { ImageDetails } from "../../../images/interfaces";

interface MediaOverlayDisplayProps {
    imageDetails: ImageDetails;
    isOverlayOpen: boolean;
    onMediaOverlayClose: (e) => void;
}

export const ImageOverlayDisplay = (props: MediaOverlayDisplayProps) => {

    const { isOverlayOpen, imageDetails, onMediaOverlayClose } = props;
    const imageSrc = getImageUrl(imageDetails, { imageSize: ImageSize.xLarge })

    if (!isOverlayOpen) return null;

    return (
        <div className="image-overlay-display">
            <div className="close-btn" onClick={onMediaOverlayClose}></div>

            <img src={imageSrc} alt="" />

            <div className="image-details">
                <div className="title">{imageDetails.caption}</div>
                <div className="credit">{imageDetails.credit}</div>
            </div>
        </div>
    )
}
